(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-blog-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class YGBlogV1 extends HTMLElement {
      connectedCallback() {
        this.formatNumbers();
      }

      formatNumbers() {
        const locale = document.documentElement.lang || navigator.language || 'en-US';
        const formatter = new Intl.NumberFormat(locale);

        this.querySelectorAll('[data-yg-number]').forEach((node) => {
          const value = Number(node.getAttribute('data-yg-number'));

          if (!Number.isNaN(value)) {
            node.textContent = formatter.format(value);
          }
        });
      }
    }

    const boot = () => {
      if (!window.customElements.get('yg-blog-v1')) {
        window.customElements.define('yg-blog-v1', YGBlogV1);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-group"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGTab extends YGUtils {
      constructor() {
        super()
        this.$btnList = this.btnList
        this.$itemList = this.itemList
      }
      
      get btnList() {
        if (!this.$btnList) {
          this.$btnList = this.querySelectorAll('.yg-tab-item')
        }
        return this.$btnList
      }
      
      get itemList() {
        if (!this.$itemList) {
          this.$itemList = this.querySelectorAll('.yg-tab-content')
        }
        return this.$itemList
      }

      handClick(e, i) {
        this.$itemList.forEach(item => item.classList.remove('active'))
        this.$btnList.forEach(item => item.classList.remove('active'))
        this.$btnList[i].classList.add('active')
        this.$itemList[i].classList.add('active')
        
        if (window.innerWidth <= 999) {
          this.$btnList[i].scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
          });
        }
      }

      connectedCallback() {
        if (this.$btnList.length > 0) {
          this.$btnList[0].classList.add('active');
        }
        if (this.$itemList.length > 0) {
          this.$itemList[0].classList.add('active');
        }
        
        this.$btnList.forEach(($item, i) => $item.addEventListener('click', (e) => this.handClick(e, i)))
      }
    }
    
    if (!window.customElements.get('yg-tab')) {
      window.customElements.define('yg-tab', YGTab)
    }
  });

  } catch(e) { console.error(e); }
})();
})();
